import { HQ_TENANT_ID } from 'src/constants/tenant-constant';

// ----------------------------------------------------------------------

/**
 * 是否总部直营租户（业务编码 0000）
 */
export function isHqTenantCode(tenantCode?: string | null): boolean {
  return tenantCode === HQ_TENANT_ID;
}
